import React from 'react';
import PropTypes from 'prop-types';

class Modal extends React.Component{
    render(){
      return (
          <div className={`modal open`} >
              <div className="modal-content" style={{...this.props.modalContentStyle}}>
                  <span className="modal-close" onClick={this.props.onClose}>&times;</span>
                  <h3 className="modal-header" style={this.props.style}>{this.props.title}</h3>
                  {this.props.children}
              </div>
          </div>
      )
    }
}

Modal.propTypes = {
    title: PropTypes.string,
    children: PropTypes.object,
    onClose: PropTypes.func,
    modalContentStyle: PropTypes.object,
};

export default Modal;